<div class="main-container"
     [ngClass]="{'show': inLoading}">
     @if(inLoading){
       <div [id]="loaderId"
            class="overlay"
            [ngClass]="{'content': withContent}">
         <div class="loader">
           <div></div>
           <div></div>
           <div></div>
           <div></div>
         </div>
       </div>
     }
  <ng-content></ng-content>
</div>
